import { render, staticRenderFns } from "./tax-rates.vue?vue&type=template&id=0d2edcf4"
import script from "./tax-rates.vue?vue&type=script&lang=js"
export * from "./tax-rates.vue?vue&type=script&lang=js"
import style0 from "./tax-rates.vue?vue&type=style&index=0&id=0d2edcf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports